import { Card, Button, Form, Row, Col } from "react-bootstrap";
import { CartContext } from "../CartContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

function ProductCard(props) {
  // props.product - is the selling product
  const product = props.product;
  const cart = useContext(CartContext);
  const navigate = useNavigate();
  const productQuantity = cart.getProductQuantity(product.id);
  
  const handleImageClick = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <Card
      style={{
        border: "none",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
      }}
    >
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#f8f9fa",
          borderRadius: "12px 12px 0 0",
          width: "100%",
          height: "280px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          className="img-fluid"
          src={product.img}
          alt={product.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            padding: "20px",
          }}
          onClick={handleImageClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        />
      </div>
      <Card.Body
        style={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <Card.Title
          style={{
            fontSize: "1.25rem",
            fontWeight: "600",
            marginBottom: "8px",
            color: "#212529",
            lineHeight: "1.4",
          }}
        >
          {product.title}
        </Card.Title>
        <Card.Text
          style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            color: "#0d1b2a",
            marginBottom: "16px",
          }}
        >
          ${product.price.toFixed(2)}
        </Card.Text>

        {productQuantity > 0 ? (
          <>
            <div style={{ marginBottom: "12px" }}>
              <Form as={Row} style={{ alignItems: "center" }}>
                <Form.Label
                  column="true"
                  sm="6"
                  style={{ margin: 0, fontSize: "0.9rem", color: "#6c757d" }}
                >
                  In Cart: <strong style={{ color: "#0d1b2a" }}>{productQuantity}</strong>
                </Form.Label>
                <Col
                  sm="6"
                  style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}
                >
                  <Button
                    style={{
                      backgroundColor: "#0d1b2a",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 16px",
                      fontWeight: "500",
                      transition: "all 0.2s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => cart.addOneToCart(product.id)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#1a2f4a";
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(13, 27, 42, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#0d1b2a";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    +
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#0d1b2a",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 16px",
                      fontWeight: "500",
                      transition: "all 0.2s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => cart.removeOneFromCart(product.id)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#1a2f4a";
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(13, 27, 42, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#0d1b2a";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    −
                  </Button>
                </Col>
              </Form>
            </div>
            <div style={{ display: "flex", gap: "10px", marginTop: "auto" }}>
              <Button
                style={{
                  backgroundColor: "#1e3a5f",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 16px",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                  flex: 1,
                }}
                onClick={() => navigate(`/product/${product.id}`)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#2a4f7a";
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(30, 58, 95, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#1e3a5f";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                Details
              </Button>
            </div>
          </>
        ) : (
          <div style={{ display: "flex", gap: "10px", marginTop: "auto" }}>
            <Button
              style={{
                backgroundColor: "#0d1b2a",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                fontWeight: "500",
                transition: "all 0.2s ease",
                cursor: "pointer",
                flex: 1,
              }}
              onClick={() => cart.addOneToCart(product.id)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1a2f4a";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(13, 27, 42, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#0d1b2a";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Add To Cart
            </Button>
            <Button
              style={{
                backgroundColor: "#1e3a5f",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                fontWeight: "500",
                transition: "all 0.2s ease",
                cursor: "pointer",
                flex: 1,
              }}
              onClick={() => navigate(`/product/${product.id}`)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#2a4f7a";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(30, 58, 95, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#1e3a5f";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Details
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProductCard;
